import { Stack, useRouter } from 'expo-router'
import { TouchableOpacity } from 'react-native'
import Ionicons from '@expo/vector-icons/Ionicons'
import { useThemeColors } from '../../lib/useThemeColors'
import { colors, fonts } from '../../lib/theme'
import { useTranslation } from 'react-i18next'

export default function LeaguesLayout() {
  const tc = useThemeColors()
  const { t } = useTranslation()
  const router = useRouter()
  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: tc.navBg },
        headerTintColor: tc.rosa,
        headerTitleStyle: { fontFamily: fonts.condensedBold, fontSize: 15, color: tc.text },
        headerBackTitle: '',
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen
        name="settings"
        options={{
          title: t('league.settings_section'),
          // Su iOS il back automatico di expo-router a volte non compare
          // quando si arriva da un router.push assoluto: lo forziamo a mano.
          headerLeft: () => (
            <TouchableOpacity
              onPress={() => (router.canGoBack() ? router.back() : router.replace('/Leagues'))}
              hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
              style={{ paddingRight: 12 }}
            >
              <Ionicons name="chevron-back" size={24} color={tc.rosaText} />
            </TouchableOpacity>
          ),
        }}
      />
      <Stack.Screen
        name="badges"
        options={{
          title: t('badges.album_title'),
          headerLeft: () => (
            <TouchableOpacity
              onPress={() => (router.canGoBack() ? router.back() : router.replace('/Leagues'))}
              hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
              style={{ paddingRight: 12 }}
            >
              <Ionicons name="chevron-back" size={24} color={tc.rosaText} />
            </TouchableOpacity>
          ),
        }}
      />
    </Stack>
  )
}